var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"rect2"}),_c('div',{staticClass:"rect3"}),_c('div',{staticClass:"rect4"})])
}]

export { render, staticRenderFns }